import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["container", "overlay", "closeButton"]

    show() {
        this.element.classList.remove("hidden")
    }

    hide() {
        this.element.classList.add("hidden")
    }
}